import React from "react";
import { Checkbox, FormControlLabel, Grid, MenuItem, TextField } from "@mui/material";

/** Renders inputs for admin-defined custom fields (any entity). */
export function CustomFieldInputs({ fields, values = {}, errors = {}, onChange, disabled = false }) {
  const set = (key, v) => onChange({ ...values, [key]: v });
  return (
    <Grid container spacing={2}>
      {fields.map((f) => {
        const v = values[f.key];
        const common = { label: f.label, fullWidth: true, required: f.required, disabled, error: Boolean(errors[f.key]), helperText: errors[f.key] || "", size: "small" };
        let input;
        switch (f.type) {
          case "textarea":
            input = <TextField {...common} multiline minRows={2} value={v ?? ""} onChange={(e) => set(f.key, e.target.value)} />;
            break;
          case "number":
            input = <TextField {...common} type="number" value={v ?? ""} onChange={(e) => set(f.key, e.target.value === "" ? "" : Number(e.target.value))} />;
            break;
          case "date":
            input = <TextField {...common} type="date" InputLabelProps={{ shrink: true }} value={v ?? ""} onChange={(e) => set(f.key, e.target.value)} />;
            break;
          case "datetime":
            input = <TextField {...common} type="datetime-local" InputLabelProps={{ shrink: true }} value={v ? String(v).slice(0, 16) : ""} onChange={(e) => set(f.key, e.target.value)} />;
            break;
          case "dropdown":
          case "radio":
            input = (
              <TextField {...common} select value={v ?? ""} onChange={(e) => set(f.key, e.target.value)}>
                <MenuItem value="">—</MenuItem>
                {f.options.map((o) => <MenuItem key={o} value={o}>{o}</MenuItem>)}
              </TextField>
            );
            break;
          case "multiselect":
            input = (
              <TextField {...common} select SelectProps={{ multiple: true }} value={Array.isArray(v) ? v : []} onChange={(e) => set(f.key, e.target.value)}>
                {f.options.map((o) => <MenuItem key={o} value={o}>{o}</MenuItem>)}
              </TextField>
            );
            break;
          case "checkbox":
            input = <FormControlLabel control={<Checkbox checked={Boolean(v)} disabled={disabled} onChange={(e) => set(f.key, e.target.checked)} />} label={f.label} />;
            break;
          default:
            input = <TextField {...common} type={f.type === "email" ? "email" : f.type === "url" ? "url" : f.type === "phone" ? "tel" : "text"} value={v ?? ""} onChange={(e) => set(f.key, e.target.value)} />;
        }
        return <Grid item xs={12} sm={f.type === "textarea" ? 12 : 6} key={f._id || f.key}>{input}</Grid>;
      })}
    </Grid>
  );
}
